import * as React from 'react';

const MinimizeIcon = props => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_3036_219856"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <path
        d="M7.19999 9.3998V12.7939C7.19999 13.1252 6.93124 13.3939 6.59999 13.3939C6.26874 13.3939 5.99999 13.1252 5.99999 12.7939V10.8482L2.42421 14.424C2.30702 14.5412 2.1535 14.5998 1.99999 14.5998C1.84648 14.5998 1.69296 14.5412 1.57578 14.424C1.3414 14.1897 1.3414 13.81 1.57578 13.5756L5.15156 9.9998H3.20586C2.87461 9.9998 2.60586 9.73105 2.60586 9.3998C2.60586 9.06856 2.87461 8.7998 3.20586 8.7998H6.6C6.93125 8.7998 7.19999 9.06856 7.19999 9.3998Z"
        fill="#292929"
      />
      <path
        d="M14.4242 1.57617C14.1898 1.3418 13.8101 1.3418 13.5758 1.57617L9.99999 5.15196V3.20625C9.99999 2.875 9.73124 2.60625 9.39999 2.60625C9.06874 2.60625 8.79999 2.875 8.79999 3.20625V6.6004C8.79999 6.93164 9.06874 7.2004 9.39999 7.2004H12.7941C13.1254 7.2004 13.3941 6.93164 13.3941 6.6004C13.3941 6.26915 13.1254 6.0004 12.7941 6.0004H10.8484L14.4242 2.42461C14.6586 2.19024 14.6586 1.81055 14.4242 1.57617Z"
        fill="#292929"
      />
    </mask>
    <g mask="url(#mask0_3036_219856)">
      <rect width="16" height="16" fill="#292929" />
    </g>
  </svg>
);

export default MinimizeIcon;
